// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconArrowLeftLink = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="9" viewBox="0 0 11 9">
            <path
                fill="currentColor"
                d="M11,4.5 C11,4.91484404 10.6703163,5.25 10.2348381,5.25 L2.68901449,5.25 L5.28219952,7.72031236 C5.58974041,8.01328111 5.58974041,8.48789048 5.28219952,8.78085923 C5.12719846,8.92734361 4.92545171,9 4.72370496,9 C4.52195821,9 4.32070325,8.92675781 4.16717908,8.78027344 L0.230655669,5.03027344 C-0.0768852229,4.73730469 -0.0768852229,4.26269531 0.230655669,3.96972656 L4.16717908,0.219726562 C4.47471997,-0.0732421875 4.97293622,-0.0732421875 5.28047711,0.219726562 C5.588018,0.512695312 5.588018,0.987304688 5.28047711,1.28027344 L2.68901449,3.75 L10.2348381,3.75 C10.6703163,3.75 11,4.08515632 11,4.5 Z"
            />
        </svg>
    );
};

export default IconArrowLeftLink;
